import * as React from 'react';
import {Icon, Modal, Button, Form} from 'semantic-ui-react';

import _get from 'lodash/get';
import _set from 'lodash/set';

import i18n from "../../../../locale/i18n";
import RestClientInstance from "../../../../lib/RestClient";

const t = i18n.t.bind(i18n);

interface MailBoxManagementEditModalProps {
    handleRefresh: Function
}

interface MailBoxManagementEditModalState {
    open: boolean,
    data: any
}

class MailBoxManagementEditModal extends React.Component<MailBoxManagementEditModalProps, MailBoxManagementEditModalState> {

    isLoading: Boolean = false;

    constructor(props: MailBoxManagementEditModalProps) {
        super(props);

        this.state = {
            open: false,
            data: {}
        };

        this.refresh = this.refresh.bind(this);
    }

    delete () {
        RestClientInstance.delete("mailbox/" + this.state.data.storedFileId).then(
            ()=> {
                this.refresh(false, {});
                window.location.reload();
            }, ()=> {

            }
        )
    }

    save() {

        let fileData = {...this.state.data};

        fileData["file"] = undefined;

        let file = this.state.data.file;

        let formData = new FormData();

        formData.append("file", file);
        formData.append("fileData", JSON.stringify(fileData));

        RestClientInstance.post("mailbox", formData).then(
            ()=> {
                this.refresh(false, {});
                window.location.reload();
            }, ()=> {

            }
        )
    }

    componentDidMount() {
        this.props.handleRefresh(this.refresh);
    }

    refresh(open: boolean, data: any) {
        this.setState(
            {
                open: open,
                data: data
            }
        )
    }

    onChange (key: string, value: any, callback?: ()=> void) {
        let data = {...this.state.data};
        _set(data, key, value);

        this.setState({data: data}, callback);
    }

    render() {
            return(
                <Modal open={this.state.open}
                       trigger={
                            <Button icon labelPosition='right' onClick={()=>{this.refresh(true, {})}}>
                                {t("MailBoxManagement.UploadDocument")}
                                <Icon name="upload" />
                            </Button>
                       }
                >

                    <Modal.Header>{t("MailBoxManagement.UploadEditDocument")}</Modal.Header>
                    <Modal.Content scrolling>

                        <Form>

                            {
                                (!this.state.data.storedFileId) ?
                                    <>
                                        {this.state.data.file ?
                                            <p>{this.state.data.file.name}</p>
                                            : <></>}

                                        <Button
                                            content={t("Common.ChooseFile")}
                                            as={"label"}
                                            icon="file"
                                            htmlFor={"file"}
                                        />
                                        <input type="file" id="file" style={{ display: "none" }} onChange={(event) => {
                                            if (!event.target.files)
                                                return;

                                            this.onChange("file" ,event.target.files[0], ()=> {
                                                this.onChange("filename" ,this.state.data.file.name);
                                            });
                                        }} />
                                        <br/>
                                        <br/>
                                    </>
                                    : <></>
                            }

                            <Form.Input
                                label={t("MailBoxManagement.Filename")}
                                name="filename"
                                type="string"
                                required={true}
                                value={this.state.data.filename}
                                onChange={(event) =>this.onChange("filename" ,event.target.value)}
                            />
                            <Form.Input
                                label={t("MailBoxManagement.UserId")}
                                icon="user"
                                name="userId"
                                type="string"
                                required={true}
                                value={_get(this.state.data, "data.userId")}
                                onChange={(event) =>this.onChange("data.userId" ,event.target.value)}
                            />
                            <Form.Checkbox
                                label={t("MailBoxManagement.Read")}
                                name="read"
                                type="checkbox"
                                required={true}
                                checked={_get(this.state.data, "data.read")}
                                onChange={(event, data) =>this.onChange("data.read" ,data.checked)}
                            />
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        {
                            this.state.data.storedFileId ?
                            <Button color={"red"} onClick={()=>{this.delete()}}>
                                {t("Common.Delete")}
                            </Button> : <></>
                        }

                        <Button default onClick={()=>{this.refresh(false, {})}}>
                            {t("Common.Cancel")}
                        </Button>
                        <Button primary onClick={()=>{this.save()}}>
                            {t("Common.Save")}
                        </Button>
                    </Modal.Actions>
                </Modal>
            );
    }
}

export default MailBoxManagementEditModal;